import React from 'react';

import { translate } from '@vimeo/i18n-runtime';
import { Paragraph } from '@vimeo/iris/typography';

export function Copyright() {
  return (
    <Paragraph size="3">
      {translate({
        singular: '© {YEAR} Vimeo.com, Inc.',
        replacements: {
          YEAR: new Date().getFullYear().toString(),
        },
      })}
    </Paragraph>
  );
}
